'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _last2 = require('lodash/last');

var _last3 = _interopRequireDefault(_last2);

exports.default = reducer;
exports.setData = setData;
exports.increasePlaysCount = increasePlaysCount;
exports.isCanPlay = isCanPlay;
exports.getAllowedTracksInfo = getAllowedTracksInfo;

var _qim = require('qim');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_DATA = 'playstats/SET_DATA';
var INCREASE_PLAYS_COUNT = 'playstats/INCREASE_PLAYS_COUNT';

var initialState = {
  albums: {},
  tracks: {}
};

var actionsFn = {};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return actionsFn[action.type] ? actionsFn[action.type]({ state: state, action: action }) : state;
}

function getLimits(multPlays) {
  return {
    multPlays: multPlays,
    isDenied: multPlays < 0,
    isUnlimited: !multPlays
  };
}

actionsFn.RESET = function () {
  return initialState;
};

actionsFn[SET_DATA] = function (_ref) {
  var state = _ref.state,
      action = _ref.action;
  var albums = action.albums,
      tracks = action.tracks;

  return (0, _qim.update)([['albums', (0, _qim.$merge)(state.albums)], ['tracks', (0, _qim.$merge)(state.tracks)]], { albums: albums, tracks: tracks });
};

actionsFn[INCREASE_PLAYS_COUNT] = function (_ref2) {
  var state = _ref2.state,
      action = _ref2.action;
  return (0, _qim.update)(['tracks', action.trackId, function () {
    var track = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return track.multPlays > 0;
  }, ['multPlays', (0, _qim.$apply)(function (value) {
    return value - 1 || -1;
  })], (0, _qim.$apply)(function () {
    var track = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, _qim.update)([(0, _qim.$merge)(getLimits(track.multPlays))], track);
  })], state);
};

function getAlbumsStats(_ref3) {
  var albums = _ref3.albums;

  return function (dispatch, getState) {
    var state = getState().playstats;
    var albumsStats = (0, _extends3.default)({}, state.albums);

    albums.map(function (album) {
      var multPlays = album.multPlays,
          id = album.project_id,
          recipientId = album.recipient_id;

      albumsStats[id] = (0, _extends3.default)({
        id: id,
        recipientId: recipientId
      }, getLimits(multPlays));
    });

    return albumsStats;
  };
}

function getTrackStats(_ref4) {
  var track = _ref4.track,
      albumId = _ref4.albumId,
      albumStats = _ref4.albumStats;

  return (0, _extends3.default)({
    id: track.id,
    albumId: Number(albumId),
    recipientId: track.recipientId || albumStats.recipientId
  }, getLimits(albumStats.multPlays));
}

function getAlbumsTracksStats(_ref5) {
  var albumsTracks = _ref5.albumsTracks,
      albumsStats = _ref5.albumsStats;

  return function (dispatch, getState) {
    var state = getState().playstats;
    var tracksStats = (0, _extends3.default)({}, state.tracks);

    (0, _entries2.default)(albumsTracks).map(function (_ref6) {
      var _ref7 = (0, _slicedToArray3.default)(_ref6, 2),
          albumId = _ref7[0],
          albumTracks = _ref7[1];

      if (Array.isArray(albumTracks)) {
        var albumStats = albumsStats[albumId] || {};
        albumTracks.map(function (track) {
          tracksStats[track.id] = getTrackStats({ track: track, albumId: albumId, albumStats: albumStats });
        });
      }
    });

    return tracksStats;
  };
}

function setData(_ref8) {
  var _ref8$albums = _ref8.albums,
      albums = _ref8$albums === undefined ? [] : _ref8$albums,
      _ref8$albumsTracks = _ref8.albumsTracks,
      albumsTracks = _ref8$albumsTracks === undefined ? {} : _ref8$albumsTracks;

  return function (dispatch) {
    var albumsStats = dispatch(getAlbumsStats({ albums: albums }));
    var tracksStats = dispatch(getAlbumsTracksStats({ albumsTracks: albumsTracks, albumsStats: albumsStats }));

    dispatch({
      type: SET_DATA,
      albums: albumsStats,
      tracks: tracksStats
    });
  };
}

function increasePlaysCount(_ref9) {
  var trackId = _ref9.trackId;

  return function (dispatch) {
    return dispatch({
      type: INCREASE_PLAYS_COUNT,
      trackId: trackId
    });
  };
}

function isCanPlay(_ref10) {
  var trackId = _ref10.trackId,
      albumId = _ref10.albumId;

  return function (dispatch, getState) {
    var state = getState().playstats;
    var track = state.tracks[trackId] || {};
    var album = state.albums[albumId] || {};
    return !(track.isDenied || album.isDenied);
  };
}

function getAllowedTracksInfo(_ref11) {
  var tracks = _ref11.tracks,
      _ref11$currentTrackIn = _ref11.currentTrackIndex,
      currentTrackIndex = _ref11$currentTrackIn === undefined ? 0 : _ref11$currentTrackIn;

  return function (dispatch, getState) {
    var state = getState().playstats;
    var allowedTracks = [];
    var allowedIndexes = [];
    var currentAllowedTrackIndex = 0;
    var allowedNextIndex = null;
    var allowedPrevIndex = null;

    tracks.map(function (track, index) {
      var statsTrack = state.tracks[track.id] || {};
      if (!statsTrack.isDenied) {
        allowedTracks.push(track);
        allowedIndexes.push(index);
        if (index <= currentTrackIndex) {
          currentAllowedTrackIndex = index;
        }
        if (index < currentTrackIndex) {
          allowedPrevIndex = index;
        }
        if (index > currentTrackIndex && !allowedNextIndex) {
          allowedNextIndex = index;
        }
      }
    });

    if (allowedIndexes.length) {
      if (allowedNextIndex === null) {
        allowedNextIndex = allowedIndexes[0];
      }
      if (allowedPrevIndex === null) {
        allowedPrevIndex = (0, _last3.default)(allowedIndexes);
      }
    }

    return { allowedTracks: allowedTracks, allowedIndexes: allowedIndexes, allowedPrevIndex: allowedPrevIndex, allowedNextIndex: allowedNextIndex, currentAllowedTrackIndex: currentAllowedTrackIndex };
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/playstats.js
// module id = 358
// module chunks = 1